export const MAIN_URL = process.env.REACT_APP_BASE_URL || '';

export const ROUTE_PARAM = process.env.REACT_APP_ROUTE_PARAM || '';
